function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import RegularTabsAdvancedConfig from "segments/desktop/tabs/layouts/regular-tabs/regular-tabs-advanced-config";
import TagItemsGridAdvancedConfig from "segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-advanced-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
import AssetAdvancedConfig from "components/core/asset/advanced-field-config";
import SideBySideTextAndAssetAdvancedFieldsConfig from "segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config";
const { width } = TagItemsGridAdvancedConfig.fields;
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, RegularTabsAdvancedConfig.fields), {
        tabs: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 5,
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: {
                    textAndAssetTwoThirds: {
                        type: FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: _object_spread({}, FullParagraphAdvancedFieldsConfig, AssetAdvancedConfig, SideBySideTextAndAssetAdvancedFieldsConfig)
                    },
                    fullParagraph: {
                        type: FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: _object_spread({}, FullParagraphAdvancedFieldsConfig)
                    },
                    tagItems: {
                        type: FIELD_TYPES.NESTED,
                        label: "Tag Items",
                        fields: {
                            width
                        }
                    },
                    flexibleCards: {
                        type: FIELD_TYPES.NESTED,
                        label: "Flexible Cards",
                        fields: _object_spread({}, FullParagraphAdvancedFieldsConfig)
                    }
                }
            }
        }
    })
};
